module.exports = __webpack_public_path__ + "img/03.ef5d2091.svg";